import { useDispatch } from "react-redux";
import { useTheme } from "@mui/styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import NextButton from "../../BedSizeSelector/NextButton";
import React from "react";

const BedBuilderNextButton = ({
  currentStep,
  styles = {},
  onClick = () => {},
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const handleOnClick = () => {
    onClick();
  };

  return (
    <NextButton
      styles={{
        color: theme.COLORS.BLUE.darkBlueGreen,
        borderColor: theme.COLORS.BLUE.darkBlueGreen,
        marginTop: "-2rem",
        ":hover": {
          backgroundColor: theme.COLORS.BLUE.darkBlueGreen,
          color: "white",
        },
        ...styles,
      }}
      iconComponent={() => <ArrowDownwardIcon></ArrowDownwardIcon>}
      onClick={handleOnClick}
      className="col-12 mt-4 internal-next-button"
    ></NextButton>
  );
};

export default BedBuilderNextButton;
